export default __webpack_public_path__ + "static/IN-8015v6014_resTestBig3-e5f29f1be6e20d92c8be126729e4bd8e.webp";